const LeadDistribution = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center px-4">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">
        🚧 Lead Distribution Page Is Under Construction 🚧
      </h1>
      <p className="text-lg text-gray-600">
        We’re working hard to bring this page to you soon. Please check back
        later!
      </p>
    </div>
  );
};

export default LeadDistribution;
